import React, {useEffect} from "react"
import {useHelpCta} from "../AppContext"
import {iconInfo} from "../Helper/Icons"
import style from "./CtaBubble.css"

export const CtaBubble = ({name, children, left = 0, top = 0}) => {
    const helpCta = useHelpCta()

    const close = () => {
        helpCta.unset(name)
    }

    useEffect(() => {
        document.addEventListener("click", close)
        return () => {
            document.removeEventListener("click", close)
        }
    }, [])

    if (!helpCta.canShow(name)) return null

    return <div className={style.container} style={{left: `${left}px`, top: `${top}px`}}>
        <div/>
        <div/>
        <div>{children}</div>
    </div>
}

export const CtaBubbleLabel = ({children}) => {
    return <div className={style.title}>
        {iconInfo}
        <div>{children}</div>
    </div>
}